import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import Header from "../components/Header";

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-2xl font-light text-[#2C2123] mb-3 font-serif italic">
      {title}
    </h2>
    <div className="text-[#3C2F33] leading-relaxed space-y-4">{children}</div>
  </section>
);

const About = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen trubeaute-gradient">
      <Header />
      <main
        className="pt-32 pb-24 px-6 max-w-3xl mx-auto"
        data-testid="about-page"
      >
        <span className="inline-block text-xs uppercase tracking-[0.25em] text-[#9B6A6C] mb-3">
          {t("about.kicker")}
        </span>
        <h1 className="text-4xl sm:text-5xl font-light text-[#2C2123] leading-tight mb-8">
          {t("about.headline1")}{" "}
          <span className="font-serif italic text-[#5D4050]">
            {t("about.headlineWith")}
          </span>{" "}
          {t("about.headline2")}
        </h1>

        <Section title={t("about.section1Title")}>
          <p>{t("about.section1Body")}</p>
        </Section>

        <Section title={t("about.section2Title")}>
          {/* Trans component lets the translation file decide where the
              <em> emphasis lands — each language has different rhetorical
              stress patterns. */}
          <p>
            <Trans i18nKey="about.section2Body1" components={{ em: <em /> }} />
          </p>
          <p>{t("about.section2Body2")}</p>
        </Section>

        <Section title={t("about.section3Title")}>
          <ul className="list-disc list-inside space-y-2">
            <li>{t("about.promise1")}</li>
            <li>{t("about.promise2")}</li>
            <li>{t("about.promise3")}</li>
            <li>{t("about.promise4")}</li>
          </ul>
        </Section>

        <Section title={t("about.section4Title")}>
          <p>
            <Trans
              i18nKey="about.section4Body"
              components={{
                a: (
                  <Link
                    to="/privacy"
                    className="text-[#9B6A6C] underline"
                  />
                ),
              }}
            />
          </p>
        </Section>

        <Section title={t("about.section5Title")}>
          <p>
            <Trans
              i18nKey="about.section5Body"
              components={{
                a: (
                  <Link
                    to="/contact"
                    className="text-[#9B6A6C] underline"
                  />
                ),
              }}
            />
          </p>
        </Section>
      </main>
    </div>
  );
};

export default About;
